"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("../CircularProgress/CircularProgress"));
var _excluded = ["aria-label", "children", "classes", "className", "darkBackgroundTheme", "dataMetrics", "icon", "iconPosition", "loading", "status", "uppercase", "variant"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    buttonRoot: {
      '&&:active': {
        'box-shadow': 'none'
      },
      '&:focus': {
        'box-shadow': "0 0 0 4px ".concat(theme.palette.opacity.primary[800][38])
      }
    },
    circularProgressDarkError: {
      color: theme.palette.error[200]
    },
    circularProgressDarkOk: {
      color: theme.palette.success[200]
    },
    circularProgressDarkPrimary: {
      color: theme.palette.primary[200]
    },
    circularProgressError: {
      color: theme.palette.accent.redMain
    },
    circularProgressOk: {
      color: theme.palette.accent.greenMain
    },
    containedError: {
      '&&:active': {
        backgroundColor: (0, _styles.alpha)(theme.palette.accent.redMain, 0.62)
      },
      '&:focus': {
        borderColor: (0, _styles.alpha)(theme.palette.accent.redMain, 0.62),
        'box-shadow': "0 0 0 4px ".concat((0, _styles.alpha)(theme.palette.accent.redMain, 0.62))
      },
      '&:hover': {
        backgroundColor: (0, _styles.alpha)(theme.palette.accent.redMain, 0.86)
      },
      backgroundColor: theme.palette.accent.redMain,
      color: 'white'
    },
    containedOk: {
      '&&:active': {
        backgroundColor: (0, _styles.alpha)(theme.palette.accent.greenMain, 0.62)
      },
      '&:focus': {
        'box-shadow': "0 0 0 4px ".concat((0, _styles.alpha)(theme.palette.accent.greenMain, 0.62))
      },
      '&:hover': {
        backgroundColor: (0, _styles.alpha)(theme.palette.accent.greenMain, 0.86)
      },
      backgroundColor: theme.palette.accent.greenMain,
      color: 'white'
    },
    iconButtonLeft: {
      paddingLeft: theme.spacing(1)
    },
    iconButtonRight: {
      paddingRight: theme.spacing(1)
    },
    iconLeft: {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(0.5)
    },
    iconMedium: {
      height: '24px',
      width: '24px'
    },
    iconRight: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0)
    },
    iconSmall: {
      height: '16px',
      width: '16px'
    },
    loading: {
      backgroundColor: theme.palette.opacity.primary[800][14],
      pointerEvents: 'none'
    },
    loadingDarkError: {
      backgroundColor: theme.palette.opacity.error[200][24]
    },
    loadingDarkOk: {
      backgroundColor: theme.palette.opacity.ok[200][24]
    },
    loadingDarkPrimary: {
      backgroundColor: theme.palette.opacity.primary[200][24]
    },
    loadingError: {
      backgroundColor: theme.palette.opacity.error[900][14]
    },
    loadingOk: {
      backgroundColor: theme.palette.opacity.ok[500][14]
    },
    outlined: {
      '&:hover': {
        borderColor: 'inherit'
      },
      borderColor: 'inherit'
    },
    outlinedError: {
      '&&:active': {
        backgroundColor: (0, _styles.alpha)(theme.palette.accent.redMain, 0.14)
      },
      '&:focus': {
        'box-shadow': "0 0 0 4px ".concat((0, _styles.alpha)(theme.palette.accent.redMain, 0.38))
      },
      '&:hover': {
        backgroundColor: (0, _styles.alpha)(theme.palette.accent.redMain, 0.08)
      },
      borderColor: theme.palette.accent.redMain,
      color: theme.palette.accent.redMain
    },
    outlinedOk: {
      '&&:active': {
        backgroundColor: (0, _styles.alpha)(theme.palette.accent.greenMain, 0.14)
      },
      '&:focus': {
        'box-shadow': "0 0 0 4px ".concat((0, _styles.alpha)(theme.palette.accent.greenMain, 0.38))
      },
      '&:hover': {
        backgroundColor: (0, _styles.alpha)(theme.palette.accent.greenMain, 0.08)
      },
      borderColor: theme.palette.accent.greenMain,
      color: theme.palette.accent.greenMain
    },
    sizeSmallRoot: {
      fontSize: '14px',
      fontWeight: '500'
    },
    textTransformDisabled: {
      textTransform: 'none'
    },
    themeDarkDisabled: {
      '&$themeDarkPrimary, &$themeDarkSecondary': {
        color: theme.palette.opacity.white[50]
      }
    },
    themeDarkPrimary: {
      '&:hover': {
        backgroundColor: theme.palette.opacity.black[24]
      },
      // 'active' block need to be placed below 'hover' block to have effect
      // eslint-disable-next-line sort-keys
      '&:active': {
        backgroundColor: theme.palette.opacity.black[38]
      },
      color: theme.palette.primary[500]
    },
    themeDarkSecondary: {
      '&:hover': {
        backgroundColor: theme.palette.opacity.black[14],
        color: theme.palette.white
      },
      // 'active' block need to be placed below 'hover' block to have effect
      // eslint-disable-next-line sort-keys
      '&:active': {
        backgroundColor: theme.palette.opacity.black[24],
        color: theme.palette.white
      },
      color: theme.palette.opacity.white[70]
    },
    variantText: {
      padding: theme.spacing(0, 2)
    },
    variantTextMediumIconLeft: {
      padding: theme.spacing(0, 2, 0, 1)
    },
    variantTextMediumIconRight: {
      padding: theme.spacing(0, 1, 0, 2)
    },
    variantTextSmall: {
      padding: theme.spacing(0, 1)
    }
  };
});
var defaultProps = {
  dataMetrics: {
    root: 'fuse_button'
  },
  fullWidth: false,
  iconPosition: 'left',
  size: 'medium',
  uppercase: false,
  variant: 'contained'
};

/**
 * The buttons across Proofpoint products will utilize three styles: contained, outlined, and text.
 * Contained is considered the primary button type with outlined acting as secondary with text buttons acting as an alternate secondary or as tertiary actions.
 */
var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _cx, _cx2, _cx3;
  var ariaLabel = props['aria-label'],
    children = props.children,
    classes = props.classes,
    className = props.className,
    darkBackgroundTheme = props.darkBackgroundTheme,
    dataMetrics = props.dataMetrics,
    icon = props.icon,
    iconPosition = props.iconPosition,
    loading = props.loading,
    status = props.status,
    uppercase = props.uppercase,
    variant = props.variant,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var localClasses = useStyles();
  var mergedClasses = _objectSpread({}, localClasses, {}, classes);
  var iconComponent = icon ? /*#__PURE__*/_react["default"].cloneElement(icon, {
    className: (0, _classnames["default"])(icon.props.className, (_cx = {}, (0, _defineProperty2["default"])(_cx, mergedClasses.iconLeft, iconPosition === 'left'), (0, _defineProperty2["default"])(_cx, mergedClasses.iconRight, iconPosition === 'right'), (0, _defineProperty2["default"])(_cx, mergedClasses.iconSmall, rest.size === 'small'), (0, _defineProperty2["default"])(_cx, mergedClasses.iconMedium, rest.size === 'medium'), _cx))
  }) : null;
  var isLoadingDarkTheme = loading && darkBackgroundTheme === 'primary';
  var isDarkTheme = variant.toLowerCase() === 'text' && darkBackgroundTheme;

  // ACCESSIBILITY
  var accessibilityLabel = function accessibilityLabel() {
    var buttonName = typeof children === 'string' ? children : '';
    var labelText = ariaLabel || buttonName;
    if (loading) {
      return labelText ? "".concat(labelText, "-loading") : 'Loading';
    }
    return labelText;
  };
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    "aria-label": accessibilityLabel(),
    classes: _objectSpread({
      outlined: mergedClasses.outlined,
      root: mergedClasses.buttonRoot,
      sizeSmall: mergedClasses.sizeSmallRoot,
      text: mergedClasses.variantText
    }, classes),
    className: (0, _classnames["default"])(className, (_cx2 = {}, (0, _defineProperty2["default"])(_cx2, mergedClasses.iconButtonLeft, icon && iconPosition === 'left'), (0, _defineProperty2["default"])(_cx2, mergedClasses.iconButtonRight, icon && iconPosition === 'right'), (0, _defineProperty2["default"])(_cx2, mergedClasses.loading, loading), (0, _defineProperty2["default"])(_cx2, mergedClasses.loadingDarkError, isLoadingDarkTheme && status === 'error'), (0, _defineProperty2["default"])(_cx2, mergedClasses.loadingDarkOk, isLoadingDarkTheme && status === 'ok'), (0, _defineProperty2["default"])(_cx2, mergedClasses.loadingDarkPrimary, isLoadingDarkTheme && !status), (0, _defineProperty2["default"])(_cx2, mergedClasses.loadingError, !darkBackgroundTheme && loading && status === 'error'), (0, _defineProperty2["default"])(_cx2, mergedClasses.loadingOk, !darkBackgroundTheme && loading && status === 'ok'), (0, _defineProperty2["default"])(_cx2, mergedClasses.outlinedError, !loading && variant === 'outlined' && status === 'error'), (0, _defineProperty2["default"])(_cx2, mergedClasses.outlinedOk, !loading && variant === 'outlined' && status === 'ok'), (0, _defineProperty2["default"])(_cx2, mergedClasses.containedError, !loading && variant === 'contained' && status === 'error'), (0, _defineProperty2["default"])(_cx2, mergedClasses.containedOk, !loading && variant === 'contained' && status === 'ok'), (0, _defineProperty2["default"])(_cx2, mergedClasses.textTransformDisabled, !uppercase), (0, _defineProperty2["default"])(_cx2, mergedClasses.themeDarkPrimary, isDarkTheme && darkBackgroundTheme.toLowerCase() === 'primary'), (0, _defineProperty2["default"])(_cx2, mergedClasses.themeDarkSecondary, isDarkTheme && darkBackgroundTheme.toLowerCase() === 'alternative'), (0, _defineProperty2["default"])(_cx2, mergedClasses.themeDarkDisabled, isDarkTheme && rest.disabled), (0, _defineProperty2["default"])(_cx2, mergedClasses.variantTextSmall, !loading && variant.toLowerCase() === 'text' && rest.size === 'small'), (0, _defineProperty2["default"])(_cx2, mergedClasses.variantTextMediumIconLeft, !loading && variant.toLowerCase() === 'text' && rest.size === 'medium' && icon && iconPosition === 'left'), (0, _defineProperty2["default"])(_cx2, mergedClasses.variantTextMediumIconRight, !loading && variant.toLowerCase() === 'text' && rest.size === 'medium' && icon && iconPosition === 'right'), _cx2)),
    color: "primary",
    "data-metrics": mergedDataMetrics.root,
    ref: ref,
    variant: variant
  }, rest), iconPosition === 'left' && iconComponent, loading ? /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    className: (0, _classnames["default"])(className, (_cx3 = {}, (0, _defineProperty2["default"])(_cx3, mergedClasses.circularProgressDarkError, isLoadingDarkTheme && status === 'error'), (0, _defineProperty2["default"])(_cx3, mergedClasses.circularProgressDarkOk, isLoadingDarkTheme && status === 'ok'), (0, _defineProperty2["default"])(_cx3, mergedClasses.circularProgressDarkPrimary, isLoadingDarkTheme && !status), (0, _defineProperty2["default"])(_cx3, mergedClasses.circularProgressError, !darkBackgroundTheme && status === 'error'), (0, _defineProperty2["default"])(_cx3, mergedClasses.circularProgressOk, !darkBackgroundTheme && status === 'ok'), _cx3)),
    size: "20px",
    thickness: 6
  }) : children, iconPosition === 'right' && iconComponent);
});
Button.defaultProps = defaultProps;
Button.displayName = 'Button';
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * **Recommended** If you are not passing for accessibility compliance.
   */
  'aria-label': _propTypes["default"].string,
  /**
   * The content of the button.
   * Passing in a string will be minimally compliant (See Accessibility).
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/button/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  /**
   * Style variations for use on dark backgrounds. Note: Only works with 'text' variant.
   */
  darkBackgroundTheme: _propTypes["default"].oneOf(['alternative', 'primary']),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes["default"].string,
  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes["default"].bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes["default"].string,
  /**
   * Optional icon to render within the button,
   * if no iconPosition prop is provided, 'left' will be the default.
   * */
  icon: _propTypes["default"].element,
  /**
   * Where to render the icon within the button.
   * Has no effect if icon icon prop isn't provided.
   * */
  iconPosition: _propTypes["default"].oneOf(['left', 'right']),
  /**
   * If `true`, the button will use the loading style.
   */
  loading: _propTypes["default"].bool,
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes["default"].oneOf(['small', 'medium']),
  /**
   * The style of the component.
   */
  status: _propTypes["default"].oneOf(['error', 'ok']),
  /**
   * @ignore
   */
  type: _propTypes["default"].string,
  /**
   * If false, uppercase conversion will not be applied to button text.
   */
  uppercase: _propTypes["default"].bool,
  /**
   * The variant to use.
   * __WARNING__: `flat` and `raised` are deprecated.
   * Instead use `text` and `contained` respectively.
   * __WARNING__: `fab` and `extendedfab` are deprecated. Use the [[Fab] Component](https://material-ui.com/api/fab/) instead.
   */
  variant: _propTypes["default"].oneOf(['text', 'outlined', 'contained'])
} : {};
var _default = Button;
exports["default"] = _default;